<template>
  <div class="dynamic-form flex flex-1">
    <!--左侧选择组件-->
    <div class="left-content">
      <el-scrollbar style="height: 100%">
        <draggable
          :list="commonComponents"
          :group="{ name: 'componentsGroup', pull: 'clone', put: false }"
          :clone="cloneComponent"
          draggable=".components-item"
          :sort="false"
          @end="onEnd"
        >
          <div
            v-for="(element, index) in commonComponents"
            :key="index"
            class="components-item"
          >
            <div class="components-body flex row-between">
              {{ element.label }}
            </div>
          </div>
        </draggable>
      </el-scrollbar>
    </div>

    <!--中间自定义表单编辑-->
    <div class="center-content flex-1">
      <el-scrollbar style="height: 100%">
        <el-form
          :size="formConf.size"
          :label-position="formConf.labelPosition"
          :disabled="formConf.disabled"
          :label-width="formConf.labelWidth + 'px'"
        >
          <draggable
            class="drawing-board float-wrapper"
            :list="drawingList"
            :animation="200"
            group="componentsGroup"
            @end="onMainDragEnd"
          >
            <draggable-item
              v-for="(element, index) in drawingList"
              :key="element.renderKey"
              :drawing-list="drawingList"
              :element="element"
              :index="index"
              :active-id="activeId"
              :form-conf="formConf"
              :put="shouldClone"
              @activeItem="activeFormItem"
              @copyItem="drawingItemCopy"
              @deleteItem="drawingItemDelete"
            />
          </draggable>
        </el-form>
      </el-scrollbar>
    </div>

    <!--右侧自定义表单属性-->
    <div class="right-content">
      <right-panel
        :active-data="activeData"
        :form-conf="formConf"
        :show-field="!!drawingList.length"
        :could-change-require="!isProCondition(activeData)"
      />
    </div>
  </div>
</template>

<script>
// 组件
import Draggable from 'vuedraggable'
import DraggableItem from '@/components/workflow/DynamicForm/DraggableItem'
import RightPanel from '@/components/workflow/DynamicForm/RightPanel'

// 数据与配置
import { inputComponents, commonComponents, formConf } from './utils/config'

// 定义全局变量
let tempActiveData

export default {
  name: 'DynamicForm',

  components: { Draggable, DraggableItem, RightPanel },

  data() {
    return {
      // 组件配置
      formConf,
      inputComponents,
      commonComponents,

      // 中间容器的绘制组件列表
      drawingList: [],
      activeId: 0,
      activeData: {}
    }
  },

  methods: {
    isFilledPCon(formIds) {
      const processCmp = this.$parent.$children.find(t => t.isProcessCmp)
      return processCmp && processCmp.isFilledPCon(formIds)
    },

    /**
     * 阻止表格中嵌套行容器
     * 定制组件不能添加子组件
     */
    shouldClone(to, from, target, event, conf) {
      const targetConf = target._underlying_vm_
      const isRowContainer =
        conf.cmpType === 'common' && conf.rowType === 'layout'
      if (isRowContainer) return true
      if (conf.cmpType === 'custom') return false
      if (conf.rowType === 'table') {
        if (targetConf.layout === 'rowFormItem') return false
        if (this.isFilledPCon([targetConf.formId])) return false
      }
      return true
    },

    /**
     * 将自定义元素设置为active状态
     */
    activeFormItem(element) {
      if (element) {
        this.activeData = element
        this.activeId = element.formId
      }
    },

    /**
     * 左侧拖拽组件结束时的触发函数
     */
    onEnd(obj, a) {
      if (obj.from !== obj.to) {
        this.activeId = tempActiveData.formId
        this.activeData = tempActiveData
      }
    },

    /**
     * 拖拽结束，触发的函数
     */
    onMainDragEnd(obj, a) {
      this.activeFormItem(this.drawingList[obj.newIndex])
    },

    /**
     * 获取drawingList中相同tagName组件的数量
     */
    getSameTagCmpNum(tag) {
      return this.drawingList.reduce((count, item) => {
        if (item.children) {
          return (
            count +
            item.children.reduce((c, t) => {
              return t.tag === tag ? c + 1 : c
            }, 0)
          )
        }
        return item.tag === tag ? count + 1 : count
      }, 0)
    },

    createCmpLabel(cmp) {
      const len = this.getSameTagCmpNum(cmp.tag)
      return len ? cmp.label + len : cmp.label
    },

    /**
     * 获取中间容器中已定义元素数量
     * （因为这里formId的值是加入时的组件数量加1定义的）
     */
    getMaxId() {
      if (this.drawingList.length) {
        let maxId = 0
        const loop = (data, parent) => {
          if (!data) return
          Array.isArray(data.children) &&
            data.children.forEach(child => loop(child, data))
          if (Array.isArray(data)) {
            data.forEach(loop)
          } else {
            maxId = Math.max(data.formId, maxId)
          }
        }
        loop(this.drawingList)
        return maxId
      }
      return 0
    },

    /**
     * 获取下一个组件的formId
     */
    getNextId() {
      const maxId = this.getMaxId() + 1
      return maxId
    },

    /**
     * 判断是否已被流程图作为条件必填项了
     */
    isProCondition(cmp) {
      if (Array.isArray(cmp.children) && cmp.children.length) {
        // 容器组件需要检查子元素
        if (cmp.rowType === 'table') return false // 表格的子元素不可能为流程条件
        let flag = false
        const loop = el => {
          if (flag) return // flag === true 代表找到了一个了 不需要再找下一个
          if (Array.isArray(el)) {
            el.some(e => {
              if (e.children) loop(e.children)
              return this.checkColItem(e)
            }) && (flag = true)
          }
        }
        loop(cmp.children)
        return flag
      } else {
        return this.checkColItem(cmp)
      }
    },

    /**
     *
     */
    checkColItem(cmp) {
      if (!cmp) return false

      return this.isFilledPCon([cmp.formId])
    },

    /**
     * 复制表单项的回调函数
     */
    drawingItemCopy(item, parent) {
      let clone = JSON.parse(JSON.stringify(item))
      clone = this.createIdAndKey(clone)
      parent.push(clone)
      this.activeFormItem(clone)
    },

    /**
     * 删除自定义表单项的回调函数
     */
    drawingItemDelete(index, parent) {
      // 首先判断是否是流程条件 再判断是否有节点使用过
      if (this.isProCondition(parent[index])) {
        this.$message.warning('该组件已作为流程判断条件，无法删除')
        return
      }

      parent.splice(index, 1)
      this.$nextTick(() => {
        const len = this.drawingList.length
        if (len) {
          this.activeFormItem(this.drawingList[len - 1])
        }
      })
    },

    /**
     * 创建克隆元素的formId和renderKey
     */
    createIdAndKey(item) {
      item.formId = this.getNextId()
      item.renderKey = item.formId + new Date().getTime()
      if (item.layout === 'colFormItem') {
        item.vModel = `field${item.formId}`
      } else if (item.layout === 'rowFormItem') {
        item.componentName = `row${item.formId}`
      }
      if (Array.isArray(item.children)) {
        item.children = item.children.map(childItem =>
          this.createIdAndKey(childItem)
        )
      }
      return item
    },

    /**
     * 克隆组件，将左侧的组件克隆到中间容器中进行显示
     * @param origin
     * @returns {*}
     */
    cloneComponent(origin) {
      const clone = JSON.parse(JSON.stringify(origin))
      clone.formId = this.getNextId()
      clone.renderKey = clone.formId + new Date().getTime() // 改变renderKey后可以实现强制更新组件
      if (!clone.layout) clone.layout = 'colFormItem'

      if (clone.layout === 'colFormItem') {
        clone.label = this.createCmpLabel(clone)
        clone.vModel = `field${clone.formId}`
        clone.placeholder !== undefined && (clone.placeholder += clone.label)

        tempActiveData = clone
      } else if (clone.layout === 'rowFormItem') {
        if (clone.rowType === 'table') {
          clone.vModel = `field${clone.formId}`
        }
        clone.componentName = `row${clone.formId}`
        clone.gutter = this.formConf.gutter
        this.cloneChildrenOfRowFormItem(clone)

        tempActiveData = clone
      }

      return tempActiveData
    },

    /**
     * 克隆组件的子组件
     * @param rowFormItem
     */
    cloneChildrenOfRowFormItem(rowFormItem) {
      if (rowFormItem.children && rowFormItem.children.length) {
        const children = rowFormItem.children
        children.forEach((clone, index) => {
          clone.formId = rowFormItem.formId + index + 1
          clone.renderKey = clone.formId + new Date().getTime() // 改变renderKey后可以实现强制更新组件

          if (!clone.layout) clone.layout = 'colFormItem'
          if (clone.layout === 'colFormItem') {
            clone.vModel = `field${clone.formId}`
            clone.placeholder !== undefined &&
              (clone.placeholder += clone.label)
          } else if (clone.layout === 'rowFormItem') {
            delete clone.label
            clone.componentName = `row${clone.formId}`
            clone.gutter = this.formConf.gutter
            this.cloneChildrenOfRowFormItem(clone)
          }
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.dynamic-form {
  width: 100%;
  overflow: hidden;

  // --------------- 左侧样式 ----------------
  .left-content {
    width: 300px;
    height: 100%;
    overflow: hidden;
    background: $white-color;

    ::v-deep .el-scrollbar__wrap {
      overflow-x: hidden !important;
    }

    .components-item {
      display: inline-block;
      width: 136px;
      height: 36px;
      margin: 3px;

      .components-body {
        height: 100%;
        padding: 0 18px;
        font-size: 12px;
        border-radius: 2px;
        border: 1px solid $border-color;
        cursor: move;
      }
    }
  }

  // --------------- 中间自定义表单的样式 ---------------
  .center-content {
    height: 100%;
    background-color: $white-color;
    margin-left: 10px;
    padding: 20px;
    overflow: hidden;

    ::v-deep .el-scrollbar__wrap {
      overflow-x: hidden !important;
    }

    .drawing-board {
      box-sizing: border-box;
      min-height: calc(100vh - 115px - 2.5rem);
      overflow: auto;
      padding: 20px;
      border-radius: 5px;
      background-color: $body-background-color;

      .components-item.sortable-ghost {
        width: 100%;
        height: 60px;
        overflow: hidden;
        font-size: 0;
        border-top: 2px solid $primary-color;
        background-color: $white-background-color;
      }
    }
  }

  // --------------- 右侧样式 ----------------
  .right-content {
    width: 350px;
    height: 100%;
    overflow: hidden;
    margin-left: 10px;
    background-color: $white-color;
  }
}
</style>
